import {IntermediatePart} from "../../intermediatePart";

export default class OverheadRack extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'overhead_rack';
    this.partName = 'Overhead Rack';
    this.translateId = "visualizer.laundryRoom.overheadRack";
    this.canBeDisabled = true;
  }

}
